export const translations = {
	'Service configuration': {
		en: 'Service configuration',
		no: 'Tjenestekonfigurasjon',
	},
	'Monitoring of service': {
		en: 'Monitoring of service',
		no: 'Overvåking av tjeneste',
	},
	'Service name': {
		en: 'Service name',
		no: 'Tjenestenavn',
	},
	'Startup type': {
		en: 'Startup type',
		no: 'Oppstartstype',
	},
	'State': {
		en: 'State',
		no: 'Status',
	},
	'Monitor stopped': {
		en: 'Monitor stopped',
		no: 'Monitor stoppet',
	},
	'Monitor paused': {
		en: 'Monitor paused',
		no: 'Monitor pause',
	},
	'Restart on failure': {
		en: 'Restart on failure',
		no: 'Omstart ved feil',
	},
	'Force schedule': {
		en: 'Force schedule',
		no: 'Tvungen start',
	},
	'Force interval': {
		en: 'Force interval',
		no: 'Tvunget intervall',
	},
	'Duration': {
		en: 'Duration',
		no: 'Varighet',
	},
	'Services': {
		en: 'Services',
		no: 'Tjenester',
	},
	'Create profile': {
		en: 'Create profile',
		no: 'Opprett profil',
	},
	'Profile type': {
		en: 'Profile type',
		no: 'Profiltype',
	},
	'Profile name': {
		en: 'Profile name',
		no: 'Profilnavn',
	},
	'By selection': {
		en: 'By selection',
		no: 'Etter utvalg',
	},
	'By startup': {
		en: 'By startup',
		no: 'Etter oppstart',
	},
	'Service full name': {
		en: 'Service full name',
		no: 'Fullstendig tjenestenavn',
	},
	'Alert message': {
		en: 'Alert message',
		no: 'Varselmelding',
	},
	'Expected state': {
		en: 'Expected state',
		no: 'Forventet tilstand',
	},
	'Force state schedule': {
		en: 'Force state schedule',
		no: 'Tidsplan for tvungen tilstand',
	},
	'Select services': {
		en: 'Select services',
		no: 'Velg tjenester',
	},
	'Startup types': {
		en: 'Startup types',
		no: 'Oppstartstyper',
	},
	'Log on as': {
		en: 'Log on as',
		no: 'Logg på som',
	},
	'Add selected': {
		en: 'Add selected',
		no: 'Legg til valgte',
	},
	'Add service': {
		en: 'Add service',
		no: 'Legg til tjeneste',
	},
	'Selected services': {
		en: 'Selected services',
		no: 'Valgte tjenester',
	},
	'Manually select which services to monitor and set the expected state for each.': {
		en: 'Manually select which services to monitor and set the expected state for each.',
		no: 'Velg manuelt hvilke tjenester som skal overvåkes, og angi forventet tilstand for hver av dem.',
	},
	'Monitor all services with a given startup type and set expected state. Individual services can be excluded from monitoring.':
		{
			en: 'Monitor all services with a given startup type and set expected state. Individual services can be excluded from monitoring.',
			no: 'Overvåk alle tjenester med en gitt oppstartstype, og angi forventet tilstand. Enkelte tjenester kan utelates fra overvåkingen.',
		},
	'Click Create profile button to get started': {
		en: 'Click Create profile button to get started',
		no: 'Klikk på Opprett profil knappen for å komme i gang',
	},
	'Select an asset and select Override from menu to create an override profile': {
		en: 'Select an asset and select Override from menu to create an override profile',
		no: 'Velg en ressurs og velg Overstyr fra menyen for å opprette en overstyringsprofil',
	},
	"You can't delete this. It's inherited from the default profile.": {
		en: 'You cant delete this. It is inherited from the default profile',
		no: 'Du kan ikke slette dette. Det arves fra standardprofilen.',
	},
	'Excluded services': {
		en: 'Excluded services',
		no: 'Ekskluderte tjenester',
	},
	'(from default)': {
		en: '(from default)',
		no: '(fra standard)',
	},
	'Startup configuration': {
		en: 'Startup configuration',
		no: 'Oppstartskonfigurasjon',
	},
	'Click here or maximize button to see profile': {
		no: 'Klikk her eller maksimer knapp for å se profilen',
	},
	'Maximize': {
		no: 'Maksimer',
	},
	'Minimize': {
		no: 'Minimer',
	},
};
